export default __webpack_public_path__ + "./assets/banner__750df91d480e8327896e616bf838327b.jpg";